import { TextArea } from '@rbilabs/universal-components';

import { primitive, spacing } from 'styles/constants';
export const InstructionsTextarea = TextArea.withConfig({
  width: 'full',
  fontSize: 'md',
  borderWidth: '1px',
  borderColor: primitive.$greyFour,
  borderRadius: primitive.$borderRadius,
  paddingY: '$4',
  paddingLeft: '$4',
  paddingRight: '$2',
  marginRight: '$0',
  marginTop: spacing.$2_5,
  marginBottom: '$5',
  _focus: {
    outline: 'none',
    borderColor: primitive.$fieryRed,
  },
});
